import React from 'react';
import { useState, useEffect } from 'react';
import { Container } from "@magnetic/container";
import { fetchApi } from "../../helpers/api/fetch-api";
import { UserCodeValidate } from "../../helpers/models";

import "./index.scss";
import { Organization } from "../../helpers/pre-authorization-transformer";
import OrganizationList from './OrganizationList';
import UserCodeInput from './UserCodeInput';
import SuccessScreen from './SuccessScreen';
import LogoBanner from './LogoBanner';

type DeviceAuthPageProps = {
  apiBasePath: string;
};

const DeviceAuth = ({ apiBasePath }: DeviceAuthPageProps) => {
  const [userCode, setUserCode] = useState<string>("");
  const [userCodeError, setUserCodeError] = useState<string>("");
  const [showOrganizationList, setShowOrganizationList] = useState<boolean>(false);
  const [showAuthorizedScreen, setShowAuthorizedScreen] = useState<boolean>(false);
  const [organizations, setOrganizations] = useState<Organization[]>([]);
  const [selectedOrganization, setSelectedOrganization] = useState<
    Organization | undefined
  >(undefined);
  const [authorizeError, setAuthorizeError] = useState<string>("");

  const csrf =
    document
      .querySelector("meta[name='csrf-token']")
      ?.getAttribute("content") || "";

  const authOptions = {
    auth: {
      csrfToken: csrf,
    },
  };

  useEffect(() => {
    const urlSearchString = window.location.search;
    const params = new URLSearchParams(urlSearchString);
    setUserCode(params.get("user_code") || "");
  }, []);

  const validateUserCode = async () => {
    setUserCodeError("");

    const [response, errors] = await fetchApi<UserCodeValidate>(
      "POST",
      `${apiBasePath}/validate`,
      {
        user_code: userCode,
      },
      authOptions
    );

    if (response) {
      setShowOrganizationList(true);
      setOrganizations(response.data.organizations);
      setUserCodeError("");
    }

    if (errors.length > 0) {
      setUserCodeError(errors.join(", "));
    }
  };

  const authorizeOrganization = async () => {
    setAuthorizeError("");

    const [response, errors] = await fetchApi(
      "POST",
      `${apiBasePath}`,
      {
        user_code: userCode,
        organization_id: selectedOrganization.id
      },
      authOptions
    );

    if (response) {
      setAuthorizeError("");
      setShowAuthorizedScreen(true);
      setShowOrganizationList(false);
    }

    if (errors.length > 0) {
      setAuthorizeError(errors.join(", "));
    }
  };

  const handleCancel = () => {
    setUserCode("");
    setUserCodeError("");
  };

  const handleOrganizationCancel = () => {
    setUserCode("");
    setUserCodeError("");
    setAuthorizeError("");
    setShowOrganizationList(false);
    setOrganizations(undefined);
    setSelectedOrganization(undefined);
  };


  return (
    <div>
      <LogoBanner/>
      <Container className="device-auth-container">
      {showOrganizationList &&
        <OrganizationList
          organizations={organizations}
          selectedOrganization={selectedOrganization}
          authorizeError={authorizeError}
          setSelectedOrganization={setSelectedOrganization}
          handleOrganizationCancel={handleOrganizationCancel}
          authorizeOrganization={authorizeOrganization}
        />
      }
      {showAuthorizedScreen &&
        <SuccessScreen/>
      }
      {!showOrganizationList && !showAuthorizedScreen &&
        <UserCodeInput
        userCode={userCode}
        userCodeError={userCodeError}
        setUserCode={setUserCode}
        handleCancel={handleCancel}
        validateUserCode={validateUserCode}
      />
      }
      </Container>
    </div>
  );
};

export default DeviceAuth;
